module.exports = __webpack_public_path__ + "static/brillante-vielse-48b2f560635797544afec2610e87322a.mp4";